import React from 'react'
import Link from 'gatsby-link'
import StoreLinks from "../components/storeLinks";
import IntroParagraph from "../components/IntroParagraph";

import elm from "../content/typescript.json";
import Resources from "../components/Resources";
import SampleChapters from "../components/SampleChapters";

import appImg from "../img/ts-acc-app.png"
import appImg2 from "../img/ts-acc-app2.png"

const bookTitle = "TypeScript Accelerated";

export default () => (
  <div>
    <h1 className="elm">{bookTitle}</h1>
    <IntroParagraph />

    <h2>Apps</h2>

    <p>The primary form of TypeScript Accelerated is the App. Out now for iPhone and iPad.</p>

    <img src={appImg} />
    <img src={appImg2} />

    <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/typescript-accelerated/id1404381952?ls=1&mt=8"/>

    <p>But on this site you can also find:</p>

    <ul>
      <li><a href="#sample">Sample book chapters</a></li>
      <li><a href="#resources">Links to external resources on learning TypeScript</a></li>
    </ul>

    <SampleChapters chapters={elm.excerpts} />

    <Resources resources={elm.resources} bookTitle={bookTitle}/>
  </div>
)


// WEBPACK FOOTER //
// ./src/pages/typescript.js